/** @jsx h */
import { h } from 'preact'
import CloseIcon from './icons/CloseIcon'

const CloseButton = ({ onClose }) => (
  <button class='Action-close' onClick={onClose} type='button'>
    <CloseIcon />
  </button>
)

export default CloseButton
